"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import "../../../foundation/iconography/ExtraIconsProvider.js";
import "../../../foundation/iconography/IconVariantProvider.js";
import "../../../foundation/iconography/icons.js";
import { Icon } from "../../../foundation/iconography/Icon.js";
import { BodyText } from "../../../foundation/typography/index.js";
import { forwardRef } from "react";
import classNames from "classnames";
import "../../../foundation/logos/Logo.css.js";
import { clickAnimation } from "../../../styles/animations.css.js";
import { focusStyle, stateLayers } from "../../../styles/states.css.js";
import { chipRecipe } from "./styles.css.js";
import { actionText } from "../buttons/styles.css.js";
const TagChip = forwardRef(function TagChip2({ label, onClick, icon, density = "default", ...props }, ref) {
  return jsxs("button", { type: "button", ...props, title: label, onClick, className: classNames(chipRecipe(), clickAnimation, focusStyle, stateLayers({
    borderSize: "medium",
    borderRadius: "full",
    backgroundColor: "on-background",
    setFocusState: true
  })), ref, children: [icon && jsx(Icon, { icon, size: density === "compact" ? "m" : "l" }), jsx(BodyText, { className: actionText, children: label }), jsx(Icon, { icon: "clear", size: density === "compact" ? "m" : "l" })] });
});
export {
  TagChip
};
